import { Box } from '@mui/material';
import QuizHeader from '../../common/QuizHeader';
import QuizQuestion from '../../common/QuizQuestion';
import QuizContainer from '../../common/QuizContainer';
import QuizButton, { ButtonType } from '../../common/QuizButton';
import { useQuizState } from '../../../providers/QuizProvider/QuizProvider.hooks';
import {
  Sex,
  SEX_ANSWERS,
  TOTAL_HIGH_DENSITY_LIPOPROTEIN_ANSWERS,
  TotalHighDensityLipoprotein,
} from '../../../providers/QuizProvider/QuizProvider.types';
import QuizStepBackgroundWrapper from '../../common/QuizStepBackgroundWrapper';

function Step11() {
  const { setStep, setQuizData } = useQuizState();
  const handleClick = (type: Sex) => {
    setQuizData((prev) => ({
      ...prev,
      sex: type,
    }));
    setStep((prev) => prev + 1);
  };

  return (
    <QuizStepBackgroundWrapper>
      <QuizHeader
        onBack={() => {
          setStep((prev) => prev - 1);
        }}
        stepNumber={11}
        stepsNumber={19}
      ></QuizHeader>
      <QuizQuestion text="Which sex best describes you?"></QuizQuestion>
      <QuizContainer>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            marginBottom: '30px',
          }}
        >
          {Object.keys(SEX_ANSWERS).map((key) => (
            <QuizButton
              key={key}
              onClick={() => handleClick(key as keyof typeof SEX_ANSWERS)}
              variant={ButtonType.WHITE}
              text={SEX_ANSWERS[key as keyof typeof SEX_ANSWERS]}
            ></QuizButton>
          ))}
        </Box>
      </QuizContainer>
    </QuizStepBackgroundWrapper>
  );
}

export default Step11;
